var render, staticRenderFns
import script from "./StatActiveCardsChart.vue?vue&type=script&lang=js&"
export * from "./StatActiveCardsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612f32c2",
  null
  
)

export default component.exports